import { render, staticRenderFns } from "./ReChatWrapper.vue?vue&type=template&id=d6860972&scoped=true"
import script from "./ReChatWrapper.vue?vue&type=script&lang=js"
export * from "./ReChatWrapper.vue?vue&type=script&lang=js"
import style0 from "./ReChatWrapper.vue?vue&type=style&index=0&id=d6860972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6860972",
  null
  
)

export default component.exports